import { toast } from 'vue-sonner'
import { useCallSave } from './useCallSave.js'
import { useCallStatus } from './useCallStatus.js'

/**
 * Composable pour les actions liées aux appels
 * Limite: 150 lignes max
 */
export function useCallActions(callState, stopTimer, beforeUnloadHandler) {
  const { saveCall } = useCallSave(callState, stopTimer, beforeUnloadHandler)
  const { sendAvailabilityRequest, proposePhoneAppointment, confirmNoAnswer } = useCallStatus(callState, saveCall)

  const handleGenerateAndSendQuote = async () => {
    const generateAndSendQuoteFn = callState.callbacks.value.generateAndSendQuote
    
    if (!confirm('Générer et envoyer le devis au client ?\n\nL\'appel sera terminé une fois le devis parti.')) {
      return
    }

    if (generateAndSendQuoteFn) {
      // L'appel n'est enregistré ici QUE s'il ne l'a pas déjà été par la
      // validation de l'analyse du besoin : sans cette condition, le même
      // échange produisait deux lignes dans l'historique de la demande.
      let callSaved = Boolean(callState.savedCallId.value)
      if (!callSaved) {
        try {
          await saveCall({ skipStatusUpdate: true, sendEmail: true, keepCallActive: true })
          callSaved = true
        } catch (err) {
          toast.warning('L\'appel n\'a pas pu être enregistré, mais le devis va être envoyé')
        }
      }

      // C'est generateAndSendQuoteFn qui clôt l'appel une fois le devis parti.
      await generateAndSendQuoteFn()
      if (callSaved) {
        toast.success('Appel enregistré et devis envoyé avec succès')
      }
    }
  }

  return {
    saveCall,
    sendAvailabilityRequest,
    handleGenerateAndSendQuote,
    proposePhoneAppointment,
    confirmNoAnswer
  }
}
